import { ExcelTemplate } from '../../interfaces';
import { fitToColumn } from '../financial-statement/utils';
import { setColumnWidth, withHeaderStyling } from '../../utils';
import { getPreparedData } from './mapping';
import * as XLSX from 'xlsx-js-style';
import { CompanyWithRoundsDTO } from 'src/app/domain/company/dto/CompanyWithRoundsDTO';

export class CompanyMembersTemplate implements ExcelTemplate {
  export(data: CompanyWithRoundsDTO[]): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = getMembersSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }
}

export const getMembersSheet = (exportExcelData: CompanyWithRoundsDTO[]): XLSX.WorkSheet => {
  const headers = getHeaders();

  const preparedData = getPreparedData(exportExcelData, headers);
  const sheet = {
    ...XLSX.utils.aoa_to_sheet(preparedData),
    '!cols': fitToColumn(preparedData),
  };

  const emailColumnIndex = 3;
  const positionColumnIndex = 4;
  setColumnWidth(sheet, emailColumnIndex, 25);
  setColumnWidth(sheet, positionColumnIndex, 15);
  return withHeaderStyling(sheet);
};

export const getHeaders = (): string[] => ['Company/Member', 'Surname', 'Phone', 'Email', 'Position'];
